import { render, staticRenderFns } from "./WrongQuestionAnswerMultiple.vue?vue&type=template&id=9d741084&scoped=true&"
import script from "./WrongQuestionAnswerMultiple.vue?vue&type=script&lang=ts&"
export * from "./WrongQuestionAnswerMultiple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d741084",
  null
  
)

export default component.exports